import constants from 'constants';

const {
  CREATE_DISCIPLINE_SAGA,
  LOAD_ADMIN_DISCIPLINES_SAGA,
  ADD_ADMIN_DISCIPLINES,
  UPDATE_DISCIPLINE_SAGA,
  DELETE_DISCIPLINE_SAGA,
  ADMIN_DELETE_DISCIPLINES_SAGA,
  ADD_DISCIPLINES,
  LOAD_DISCIPLINES_SAGA,
  LOAD_DISCIPLINE_SAGA,
  SET_TEMP_DISCIPLINE,
  CLEAN_DISCIPLINES,
  ADD_SEARCH_DISCIPLINES,
  LOAD_NEW_DISCIPLINES_SAGA,
  ADD_NEW_DISCIPLINES,
  SEND_CONFIRMATION_USERS_SAGA,
  APPROVE_USER_REQUEST_SAGA,
  REJECT_USER_REQUEST_SAGA,
  APPROVE_IPNA_REQUEST_SAGA,
  REJECT_IPNA_REQUEST_SAGA
} = constants;

export const createDisciplineSaga = (discipline) => ({
  type: CREATE_DISCIPLINE_SAGA,
  discipline
})

export const updateDisciplineSaga = (discipline) => ({
  type: UPDATE_DISCIPLINE_SAGA,
  discipline
})

export const deleteDisciplineSaga = (discipline) => ({
  type: DELETE_DISCIPLINE_SAGA,
  discipline
})

export const loadAdminDisciplinesSaga = (page = 1, query = {}) => ({
  type: LOAD_ADMIN_DISCIPLINES_SAGA,
  query,
  page
})

export const loadDisciplinesSaga = (page = 1, query = {}) => ({
  type: LOAD_DISCIPLINES_SAGA,
  query,
  page
})

export const loadNewDisciplinesSaga = (page = 1, query = {}) => ({
  type: LOAD_NEW_DISCIPLINES_SAGA,
  query,
  page
})

export const sendConfirmationUsersSaga = ({confirmation_users}) => ({
  type: SEND_CONFIRMATION_USERS_SAGA,
  confirmation_users
})

export const approveUserRequestSaga = (id) => ({
  type: APPROVE_USER_REQUEST_SAGA,
  id
})

export const rejectUserRequestSaga = (id) => ({
  type: REJECT_USER_REQUEST_SAGA,
  id
})

export const approveIpnaRequestSaga = (id) => ({
  type: APPROVE_IPNA_REQUEST_SAGA,
  id
})

export const rejectIpnaRequestSaga = (id) => ({
  type: REJECT_IPNA_REQUEST_SAGA,
  id
})

export const addAdminDisciplines = (values, count, page, total_pages, query = {}) => ({
  type: ADD_ADMIN_DISCIPLINES,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const addDisciplines = (values, count, page, total_pages, query = {}) => ({
  type: ADD_DISCIPLINES,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const addSearchDisciplines = (values, count, page, total_pages, query = {}) => ({
  type: ADD_SEARCH_DISCIPLINES,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const addNewDisciplines = (values, count, page, total_pages, query = {}) => ({
  type: ADD_NEW_DISCIPLINES,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const adminDeleteDisciplineSaga = (discipline_ids) => ({
  type: ADMIN_DELETE_DISCIPLINES_SAGA,
  discipline_ids
})

export const setTempDiscipline = (discipline) => ({
  type: SET_TEMP_DISCIPLINE,
  payload: {
    discipline
  }
})

export const loadDisciplineSaga = (id) => ({
  type: LOAD_DISCIPLINE_SAGA,
  id
})

export const cleanDiscipline = () => ({
  type: CLEAN_DISCIPLINES
})



// WEBPACK FOOTER //
// ./src/actions/disciplines.js